(function ($, window, document, undefined) {
	$(function () {
		/**
		 * Benefits slider
		 */
		function benefitsSlider() {
			const splide = new Splide(".home-benefits-slider", {
				type: "loop",
				width: "100vw",
				perPage: 1,
				autoplay: true,
				gap: 50,
				arrows: false,
				breakpoints: {
					767: {
						perPage: 1,
					},
				}
			});

			splide.mount();
		}

		/**
		 * Video handling
		 */
		function videoHandling() {
			const lazyVideos = [].slice.call($("video.lazy"));

			if ("IntersectionObserver" in window) {
				const lazyVideoObserver = new IntersectionObserver(function(entries, observer) {
					entries.forEach(function(video) {
						if (video.isIntersecting) {
							for (const source in video.target.children) {
								const videoSource = video.target.children[source];
								if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
									videoSource.src = videoSource.dataset.src;
								}
							}

							video.target.load();
							video.target.classList.remove("lazy");
							lazyVideoObserver.unobserve(video.target);
						}
					});
				});

				lazyVideos.forEach(function(lazyVideo) {
					lazyVideoObserver.observe(lazyVideo);
				});
			}

			$(document).on("click touchstart", ".video-block__button", function() {
				$(".watch-now").addClass("watch-now_play");

				const roll4RollVideo = document.getElementById("roll-4-roll");
				if( roll4RollVideo ) {
					if (roll4RollVideo.requestFullscreen) {
						roll4RollVideo.requestFullscreen();
					} else if (roll4RollVideo.msRequestFullscreen) {
						roll4RollVideo.msRequestFullscreen();
					} else if (roll4RollVideo.mozRequestFullScreen) {
						roll4RollVideo.mozRequestFullScreen();
					} else if (roll4RollVideo.webkitRequestFullScreen) {
						roll4RollVideo.webkitRequestFullScreen();
					}
				}

				$(".video-block__video video")[0].play();
			});
		}

		function init() {
			// benefitsSlider();
		}

		init();

		$(window).on("load", function() {
			videoHandling();
		});
	});
})(jQuery, window, document);
